import { WHATSAPP_SCOPE } from "../../facebook/config";
import {
  WHATSAPP_COEXISTENCE_SIGNUP_CONFIG_ID,
  WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID,
  WHATSAPP_FACEBOOK_APP_ID,
  WhatsAppConnectionMode,
} from "../config";

declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}

export interface WhatsAppSignupSession {
  wabaId?: string;
  phoneNumberId?: string;
  event?: string;
}

let signupSession: WhatsAppSignupSession = {};
let sessionListenerAttached = false;

export function resetWhatsAppSignupSession() {
  signupSession = {};
}

export function getWhatsAppSignupSession(): WhatsAppSignupSession {
  return { ...signupSession };
}

export function attachWhatsAppSignupSessionListener() {
  if (sessionListenerAttached || typeof window === "undefined") {
    return;
  }

  window.addEventListener("message", (event) => {
    if (event.origin !== "https://www.facebook.com") return;

    try {
      const data =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;

      if (data?.type !== "WA_EMBEDDED_SIGNUP") return;

      signupSession.event = data.event;
      if (data.data?.waba_id) {
        signupSession.wabaId = data.data.waba_id;
      }
      if (data.data?.phone_number_id) {
        signupSession.phoneNumberId = data.data.phone_number_id;
      }
    } catch {
      // Ignore non-JSON postMessage payloads from Facebook.
    }
  });

  sessionListenerAttached = true;
}

export function launchWhatsAppSignup(
  mode: WhatsAppConnectionMode,
  callback: (res: any) => void
) {
  attachWhatsAppSignupSessionListener();
  resetWhatsAppSignupSession();

  if (!window.FB?.login) {
    throw new Error(
      "Facebook SDK not loaded. Wrap the connect button in FacebookProvider."
    );
  }

  if (!WHATSAPP_FACEBOOK_APP_ID) {
    throw new Error(
      "REACT_APP_WHATSAPP_FACEBOOK_APP_ID is not configured."
    );
  }

  const isCoexistence = mode === "coexistence";

  window.FB.login(callback, {
    config_id: isCoexistence
      ? WHATSAPP_COEXISTENCE_SIGNUP_CONFIG_ID
      : WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID,
    appId: WHATSAPP_FACEBOOK_APP_ID,
    response_type: "code",
    autoLogAppEvents: true,
    xfbml: true,
    version: "v22.0",
    scope: WHATSAPP_SCOPE,
    override_default_response_type: true,
    extras: {
      setup: {},
      featureType: isCoexistence
        ? "whatsapp_business_app_onboarding"
        : "",
      sessionInfoVersion: "3",
    },
  });
}
